





























































































  import {Component, Vue} from 'vue-property-decorator';
  import moment from 'moment';

  import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
  import IconButton from '@/components/atom/button/IconButton.vue';
  import Datepicker from '@/components/datepicker/DatePicker.vue';
  import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
  import NormalButton from '@/components/atom/button/NormalButton.vue';
  import externalMovementApi from '@/infrastructure/api/external/externalMovementApi';
  import api from '@/infrastructure/api/api';
  import router from '@/router';
  import {取込ファイル型 } from '@/type/external/file/取込ファイル';
  import {部署型} from '@/type/department/department';
  import {取込ファイル確定依頼型} from '@/type/external/request/取込ファイル確定依頼';
  import {取込ファイル明細型} from '@/type/external/file/取込ファイル明細';
  import {外部連携取込日付設定有無型} from '@/type/external/movement/外部連携取込日付設定有無型';
  import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
  import {progress} from '@/script/progress';

  @Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
  filters: {
    日付のフォーマット(date: Date): string | null {
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class ExternalCapture extends Vue {

  private file: any;
  private 取込ファイル: 取込ファイル型 =
    new 取込ファイル型('', [], '未確定', '未削除', 0);
  private メッセージ: string = '';
  private 部署一覧: 部署型[] = [];
  private 移動元部署コード: string = '';
  private アラートメッセージ: string[] = [];
  private ファイル取込番号: string = '';
  private 外部連携取込日付設定有無: 外部連携取込日付設定有無型  = new 外部連携取込日付設定有無型();
  private 移動年月日: Date = moment().toDate();

  private mounted() {
    this.initialize();
    this.ファイル取込番号 = this.$route.query.fileSeq as string;
    if (this.ファイル取込番号 == null) {
      return;
    }
    this.取込ファイルを取得するハンドラ();
  }

  private async initialize(): Promise<void> {
    this.部署一覧 = await api.部署一覧を取得する();
    this.外部連携取込日付設定有無 = await externalMovementApi.外部連携取込日付設定有無を取得する();
  }

  private 確定ボタンが非活性である(): boolean {
    return this.取込ファイル.ファイルを確定できない();
  }

  private 確定取消ボタンが非活性である(): boolean {
    return this.取込ファイル.確定取消できない();
  }

  private async 取込ファイルを取得するハンドラ() {
    await progress(this.取込ファイルを取得する);
  }

  private async 取込ファイルを取得する() {
    await externalMovementApi.取込ファイルを取得する(this.ファイル取込番号)
      .then((response: any) => {
        const 一覧 =
          response.明細一覧.一覧
            .map((it: any) => new 取込ファイル明細型(
              it.取込行番号,
              it.移動日,
              it.取込商品名,
              it.取込部署名,
              it.エラー内容));
        this.取込ファイル =
          new 取込ファイル型(
            response.ファイル名,
            一覧,
            response.外部連携ファイルヘッダー.確定フラグ,
            response.外部連携ファイルヘッダー.削除フラグ,
            response.外部連携ファイルヘッダー.更新バージョン);
      })
      .catch((error: any) => {
        this.ファイル取込番号 = '';
        throw error;
      });
  }

  private 総件数() {
    return this.取込ファイル.取込ファイル明細一覧.length;
  }

  private handleFileUpload(event: any) {
    this.取込ファイル =
      new 取込ファイル型('', [], '未確定', '未削除', 0);
    this.file = event.target.files[0];
    this.取込ファイル.ファイル名 = this.file.name;
  }

  private async ファイルを送信するハンドラ() {
    if (this.file == null) {
      this.アラートメッセージ = ['取込ファイルを選択してください'];
      this.$modal.show('アラート');
      return;
    }
    if (this.移動元部署コード === '') {
      this.アラートメッセージ = ['移動元部署コードを選択してください'];
      this.$modal.show('アラート');
      return;
    }
    if (!this.外部連携取込日付設定有無.日付設定有無) {
      if (this.移動年月日 == null) {
        this.アラートメッセージ = ['移動年月日を指定してください'];
        this.$modal.show('アラート');
        return;
      }
      const 移動年月日: any = this.$refs.移動年月日;
      if (移動年月日.$data.alert) {
        this.アラートメッセージ = ['移動年月日の書式を正しく入力してください'];
        this.$modal.show('アラート');
        return;
      }
    }

    await progress(this.ファイルを送信する);
  }

  private async ファイルを送信する() {
    const formData = new FormData();
    formData.append('file', this.file);
    formData.append('移動元部署コード', this.移動元部署コード);
    if (!this.外部連携取込日付設定有無.日付設定有無) {
      formData.append('移動年月日', moment(this.移動年月日).format('YYYY-MM-DD'));
    } else {
      formData.append('移動年月日', '1500-01-01');
    }
    const ファイル取込番号 = await externalMovementApi.ファイルをアップロードする(formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .catch((error) => {
      if (error.data.errors) {
        this.アラートメッセージ = error.data.errors;
        this.$modal.show('アラート');
        return;
      }
      if (error.data.message && !error.data.errors) {
        this.アラートメッセージ = [error.data.message];
        this.$modal.show('アラート');
        return;
      }
      this.取込ファイル =
        new 取込ファイル型(
          this.取込ファイル.ファイル名,
          error.data,
          this.取込ファイル.確定区分,
          this.取込ファイル.削除フラグ,
          this.取込ファイル.更新バージョン);
      return;
    });

    if (ファイル取込番号) {
      this.ファイル取込番号 = String(ファイル取込番号);
      await this.取込ファイルを取得する();
    }
  }

  private 取込履歴一覧を開く() {
    router.push({name: '外部連携取込履歴'});
  }

  private async Excel出力するハンドラ() {
    await progress(this.Excel出力する);
  }

  private async Excel出力する() {
    await externalMovementApi.excel出力する(this.ファイル取込番号);
  }

  private async 確定するハンドラ() {
    await progress(this.確定する);
  }

  private async 確定する() {
    let エラー一覧: [] = [];
    await externalMovementApi.取込ファイルを取得する(this.ファイル取込番号)
      .then((response: any) => {
        エラー一覧 =
          response.明細一覧.一覧
            .map((it: any) => new 取込ファイル明細型(
              it.取込行番号,
              it.移動日,
              it.取込商品名,
              it.取込部署名,
              it.エラー内容))
            .filter((it: 取込ファイル明細型) => it.エラー内容 != null);
      })
      .catch((error: any) => {
        throw error;
      });

    if (エラー一覧.length > 0) {
      this.確定確認ダイアログを開く();
      return ;
    }
    await this.確定実行する();
  }

  private async 確定実行するハンドラ() {
    await progress(this.確定実行する);
  }

  private async 確定実行する() {
    await externalMovementApi.外部連携取込を確定する(new 取込ファイル確定依頼型(this.ファイル取込番号, this.取込ファイル.更新バージョン))
      .then((response: any) => {
        this.取込ファイル.確定区分 = '確定済み';
        this.メッセージ = '確定しました';
        this.$modal.show('メッセージダイアログ');
      })
      .catch((error) => {
        if (error.data.errors) {
          this.アラートメッセージ = error.data.errors;
        }
        if (error.data.message && !error.data.errors) {
          this.アラートメッセージ = [error.data.message];
        }
        this.$modal.show('アラート');
      });
    this.確定確認ダイアログを閉じる();
  }

  private 確定確認ダイアログを開く(): void {
    this.$modal.show('確定確認ダイアログ');
  }

  private 確定確認ダイアログを閉じる(): void {
    this.$modal.hide('確定確認ダイアログ');
  }

  private メッセージダイアログを閉じる(): void {
    this.$modal.hide('メッセージダイアログ');
  }

  private async 確定取消するハンドラ() {
    await progress(this.確定取消する);
  }

  private async 確定取消する() {
    await externalMovementApi.外部連携取込の確定を取消する(new 取込ファイル確定依頼型(this.ファイル取込番号, this.取込ファイル.更新バージョン))
      .then((response: any) => {
        this.取込ファイル.確定区分 = '確定済み';
        this.メッセージ = 'ファイルの確定を取消ました';
        this.$modal.show('メッセージダイアログ');
        this.取込ファイル.削除フラグ = '削除';
      })
      .catch((error: any) => {
        if (error.data.errors) {
          this.アラートメッセージ = error.data.errors;
        }
        if (error.data.message && !error.data.errors) {
          this.アラートメッセージ = [error.data.message];
        }
        this.$modal.show('アラート');
      });
  }

  private Excel出力可能である() {
    return this.総件数() !== 0;
  }
}
